export default {
  intro: `Placez la carte sur le lecteur situé à votre gauche. Attendez 5 secondes, la carte clé sera générée. Vous pouvez ensuite retirer la carte.`,
};
